import React from 'react';
import { Tooltip } from 'react-tippy';
import { Observer } from '@poa/state';
import Select from 'react-select';
import { MultiSelectInput } from '../multi-select';


const AccountFilterTooltip = ({
                                isOpen,
                                onRequestClose,
                                onStatusChange,
                                onPageQtyChange,
                                page_size,
                                current_status,
                                onSearchClick,
                                selectedOptions,
                                onSearchItemDelete,
                                onAccountModalOpen,
                                filter_by,
                                onFilterByChange,
                                onLastSearchChange,
                                filterNames,
                                onSearchTooltipOpen,
                                onSearchChange,
                                levelOptions
                              }) => {
  return (
    <div style={{
      alignItems: 'center',
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    }}>
      <Observer>
        {() => (
          <Tooltip
            interactive={true}
            arrow={false}
            animation={'fade'}
            distance={10}
            allowHTML={true}
            open={isOpen}
            onClose={onRequestClose}
            key='search'
            theme='light'
            position='bottom'
            html={<div style={{
              background: '#fff',
              width: '100%',
              top: '50%',
              left: '50%',
              height: '600px',
              padding: '10px'
            }}>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <div style={{ maxHeight: '600px', minHeight: '600px', overflowY: 'scroll', width: '90%' }}>
                                  <div style={{ width: '100%' }}>
                  <div style={{ width: '50%', padding: '5px', float: 'left' }}>
                    <Observer>
                      {() => (
                        <div>
                          К-во на странице:
                          <Select
                            searchable={false}
                            name='sort_by'
                            menuPlacement={'bottom'}
                            menuPortalTarget={document.body}
                            captureMenuScroll={true}
                            menuShouldBlockScroll={true}
                            value={page_size}
                            menuPosition={'absolute'}
                            onChange={onPageQtyChange}
                            options={[
                              { value: 15, label: 15 },
                              { value: 25, label: 25 },
                              { value: 50, label: 50 },
                              { value: 100, label: 100 },
                              { value: 200, label: 200 }
                            ]}
                            clearable={false}
                          />
                        </div>
                      )}
                    </Observer>
                  </div>
                  <div style={{ width: '50%', padding: '5px', float: 'right' }}>
                    <Observer>
                      {() => (
                        <div>
                          статус:
                          <Select
                            searchable={false}
                            name='status'
                            value={current_status}
                            onChange={onStatusChange}
                            options={[
                              { value: 'все', label: 'все' },
                              { value: 'active', label: 'active' },
                              { value: 'inactive', label: 'inactive' },
                              { value: 'rejected', label: 'rejected' },
                              { value: 'suspended', label: 'suspended' },
                              { value: 'blocked', label: 'blocked' },
                              { value: 'deleted', label: 'deleted' },
                              { value: 'transferred', label: 'transferred' },
                              { value: 'transfered', label: 'transfered' },
                              { value: 'on verification', label: 'on verification' }
                            ]}
                            clearable={false}
                          />
                        </div>
                      )}
                    </Observer>
                  </div>
                </div>
                  {selectedOptions.map((searchRaw) => (
                    <div style={{ width: '100%', float: 'left' }} key={searchRaw}>
                      <div style={{
                        width: '30%',
                        float: 'left',
                        height: '40px',
                        position: 'relative'
                      }} key={searchRaw}>
                        <div style={{
                          width: '100%',
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          textAlign: 'center'
                        }} key={searchRaw}>
                          {filterNames[searchRaw]}
                        </div>
                      </div>
                      <div style={{ width: '60%', float: 'left' }} className='search__input input'>
                        <Observer>
                          {() => (
                            ['panels', 'managers', 'teamleads', 'scouts', 'operators', 'levels', 'account-managers'].includes(searchRaw) ?
                              <div>
                                <MultiSelectInput
                                  editMode={true}
                                  types={[searchRaw]}
                                  current={filter_by[searchRaw] || []}
                                  onChange={onFilterByChange}
                                  name={searchRaw}
                                  options={levelOptions}
                                />
                              </div>
                              :
                              <div className='search__input input' style={{ padding: '0' }}>
                                <input
                                  type='text'
                                  name={searchRaw}
                                  placeholder='поиск'
                                  value={filter_by[searchRaw] || ''}
                                  style={{ width: '100%', borderRadius: '3px', height: '34px' }}
                                  onChange={onLastSearchChange}>
                                </input>
                              </div>
                          )}
                        </Observer>
                      </div>
                      <div style={{ width: '10%', padding: '5px', float: 'right' }}>
                        <button
                          className='popup__btn popup__btn_close js-popup-close'
                          onClick={() => {
                            onSearchItemDelete(searchRaw);
                          }}
                        >
                          <svg
                            className='icon icon-cross'
                            id='icon-like'
                            viewBox='0 0 16 15'
                            width='100%'
                            height='100%'
                            style={{ fill: '#0000006e' }}
                          >
                            <path d='M16 8.63H9.17V15H6.79V8.63H0v-2.3h6.79V0h2.42v6.33H16z' />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <button
                      type='button'
                      className='filter-columns__save'
                      style={{
                        color: '#161021',
                        width: '50%',
                        margin: '15px'
                      }}
                      onClick={onAccountModalOpen}
                    >
                      + добавить поле
                    </button>
                  </div>

                  <div style={{ width: '100%', height: '34px', marginBottom: "20px" }}>
                  <div style={{ width: '50%', float: 'left' }}>
                    <button
                      type='button'
                      className='filter-columns__save'
                      style={{
                        bottom: '0',
                        height: '34px',
                        width: '50%',
                        borderRadius: '6px'
                      }}
                      onClick={onRequestClose}
                    >
                      ОТМЕНА
                    </button>
                  </div>
                  <div style={{ width: '50%', float: 'right' }}>
                    <button
                      type='button'
                      className='filter-columns__save'
                      style={{
                        bottom: '0',
                        height: '34px',
                        color: '#fff',
                        background: '#161021',
                        width: '50%',
                        borderRadius: '6px'
                      }}
                      onClick={onSearchClick}
                    >
                      ПОИСК
                    </button>
                  </div>
                </div>


                </div>

              </div>
            </div>
            }
          >
            <div style={{ verticalAlign: 'middle', width: '300px' }}>
              <div className='search__input input'>
                <input
                  type='text'
                  placeholder='поиск'
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      onSearchClick();
                    }
                  }}
                  onChange={onSearchChange}
                  onClick={onSearchTooltipOpen}>
                </input>
                <svg className='icon icon-search' width='15px' height='15px' viewBox='0 0 15 15'
                     version='1.1' xmlns='http://www.w3.org/2000/svg'>
                  <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                    <g fillRule='nonzero' fill='#DBDBDB'>
                      <path
                        d='M14.8163265,13.9346939 L11.2102041,10.3285714 C12.1040816,9.23877551 12.6428571,7.84285714 12.6428571,6.32142857 C12.6428571,2.83163265 9.81122449,0 6.32142857,0 C2.82857143,0 0,2.83163265 0,6.32142857 C0,9.81122449 2.82857143,12.6428571 6.32142857,12.6428571 C7.84285714,12.6428571 9.23571429,12.1071429 10.3255102,11.2132653 L13.9316327,14.8163265 C14.1765306,15.0612245 14.5714286,15.0612245 14.8163265,14.8163265 C15.0612245,14.5744898 15.0612245,14.1765306 14.8163265,13.9346939 Z M6.32142857,11.3846939 C3.52653061,11.3846939 1.25510204,9.11326531 1.25510204,6.32142857 C1.25510204,3.52959184 3.52653061,1.25510204 6.32142857,1.25510204 C9.11326531,1.25510204 11.3877551,3.52959184 11.3877551,6.32142857 C11.3877551,9.11326531 9.11326531,11.3846939 6.32142857,11.3846939 Z'></path>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </Tooltip>
        )}
      </Observer>
    </div>
  )
    ;
};

export default AccountFilterTooltip;
